export class ControllerStatusChangedNotificationModel
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public ControllerId: number;
    public Differences: any[];
    public IncomingConfiguration: any;
    public TypeCode: number;
}
